/* FRILLORA-PERFORMANCE-MEDIA-v1 */
(function installPerformanceMedia() {
  if (window.FrilloraPerformanceMedia) return;
  const widths = [400, 600, 800, 1000, 1400];
  const sizes = '(max-width: 980px) 100vw, 52vw';
  const warmed = new Set();
  const sources = value => {
    try {
      const url = new URL(value, document.baseURI);
      if (!/^https?:$/.test(url.protocol)) return null;
      const shopify = url.hostname === 'cdn.shopify.com' || /\/cdn\/shop\/(?:files|products)\//.test(url.pathname);
      if (!shopify) return { src: url.href, srcset: '', urls: [] };
      const urls = widths.map(width => {
        const sized = new URL(url.href); sized.searchParams.set('width', String(width));
        return sized.href;
      });
      return { src: url.href, srcset: urls.map((src, index) => src + ' ' + widths[index] + 'w').join(', '), urls };
    } catch { return null; }
  };
  const set = (image, value, alt) => {
    if (!image || !value) return;
    const next = sources(value);
    if (!next) return;
    // Replace responsive candidates before src, so a previous colour cannot win.
    if (next.srcset) {
      image.setAttribute('sizes', sizes);
      image.setAttribute('srcset', next.srcset);
    } else {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }
    image.fetchPriority = 'high';
    image.loading = 'eager';
    if (image.src !== next.src) image.src = next.src;
    if (alt) image.setAttribute('alt', alt);
  };
  const prefetch = event => {
    if (navigator.connection?.saveData || warmed.size >= 64) return;
    const button = event.target?.closest?.('[data-pdp-thumb][data-pdp-image-src], [data-product-option-button][data-pdp-image-src]');
    if (!button || button.disabled) return;
    const next = sources(button.dataset.pdpImageSrc);
    if (!next) return;
    const image = document.querySelector('[data-pdp-main-image]');
    const box = image?.getBoundingClientRect?.();
    const cssWidth = box?.width || (window.innerWidth <= 980 ? window.innerWidth : window.innerWidth * .52) || 390;
    const found = widths.findIndex(width => width >= cssWidth * (window.devicePixelRatio || 1));
    const chosen = next.urls.length ? next.urls[found < 0 ? widths.length - 1 : found] : next.src;
    if (warmed.has(chosen) || chosen === image?.currentSrc) return;
    warmed.add(chosen);
    const warm = new Image();
    warm.fetchPriority = 'low';
    warm.decoding = 'async';
    warm.src = chosen;
  };
  window.FrilloraPerformanceMedia = Object.freeze({ set });
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);
  document.addEventListener('touchstart', prefetch, { passive: true });
})();
/* FRILLORA-LOCALIZED-OPTIONS-v1 */
function frSyncCardVariantPrice(card, source) {
  if (!card || !source || typeof source.cardPrice !== 'string') return;
  const current = card.querySelector('[data-card-price-current]');
  const compare = card.querySelector('[data-card-price-compare]');
  if (current) current.textContent = source.cardPrice;
  if (compare) {
    compare.textContent = source.cardComparePrice || '';
    compare.hidden = !source.cardComparePrice;
  }
}
// FRILLORA-COLLECTION-COLOR-HANDOFF-v1
function frSyncCollectionCardLinks(card, variantId) {
  if (!card || !document.body?.classList.contains('fr-template-collection') || !/^\d+$/.test(String(variantId || ''))) return;
  // The hosiery detail filter owns the exact eligible variant and restores its own link snapshots.
  if (card.dataset.hosieryDetailed === 'true') return;
  card.querySelectorAll('.fr-card__media[href], h3 a[href]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;
    try {
      const url = new URL(href, document.baseURI);
      if (url.origin !== new URL(document.baseURI).origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
      url.searchParams.set('variant', String(variantId));
      link.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (_) {
      // A malformed optional link must not interrupt image, price or variant selection.
    }
  });
}
// FRILLORA-LOCAL-SHIPPING-v2
// FRILLORA-INTERNATIONAL-MARKET-SHIPPING-v1
// FRILLORA-AU-MARKET-COPY-v1
(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-menu-open]').forEach((button) => button.addEventListener('click', () => menu && menu.classList.add('is-open')));
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => menu && menu.classList.remove('is-open')));
  const filterButton = document.querySelector('[data-filter-toggle]');
  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterBackdrop = document.querySelector('[data-filter-backdrop]');
  const filterClose = document.querySelector('[data-filter-close]');
  const closeFilters = () => {
    filterPanel && filterPanel.classList.remove('is-open');
    if (filterBackdrop) {
      filterBackdrop.hidden = true;
      filterBackdrop.classList.remove('is-open');
    }
    document.documentElement.classList.remove('fr-filter-lock');
  };
  const openFilters = () => {
    if (!filterPanel) return;
    filterPanel.classList.add('is-open');
    if (filterBackdrop) {
      filterBackdrop.hidden = false;
      filterBackdrop.classList.add('is-open');
    }
    document.documentElement.classList.add('fr-filter-lock');
  };
  if (filterButton && filterPanel) filterButton.addEventListener('click', () => filterPanel.classList.contains('is-open') ? closeFilters() : openFilters());
  filterClose && filterClose.addEventListener('click', closeFilters);
  filterBackdrop && filterBackdrop.addEventListener('click', closeFilters);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeFilters(); });
  if (filterBackdrop && (!filterPanel || !filterPanel.classList.contains('is-open'))) closeFilters();
})();
(() => {
  if (window.FrilloraCartEnhance) return;
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-overlay]');
  const countNodes = document.querySelectorAll('[data-cart-count]');
  const linesNode = document.querySelector('[data-cart-lines]');
  const footerNode = document.querySelector('[data-cart-footer]');
  const subtotalNode = document.querySelector('[data-cart-subtotal]');
  const shippingText = document.querySelector('[data-cart-shipping-text]');
  const shippingBar = document.querySelector('[data-cart-shipping-bar]');
  const freeShippingThreshold = Math.max(1, Number(drawer && drawer.dataset.freeShippingThreshold ? drawer.dataset.freeShippingThreshold : 4500));
  const drawerLabels = {
    freeShippingUnlocked: (drawer && drawer.dataset.freeShippingUnlocked) || 'You unlocked free shipping',
    freeShippingAway: (drawer && drawer.dataset.freeShippingAway) || 'away from free shipping',
    qtyDecrease: (drawer && drawer.dataset.qtyDecreaseLabel) || 'Decrease quantity',
    qtyIncrease: (drawer && drawer.dataset.qtyIncreaseLabel) || 'Increase quantity',
  };
  const isAustralia = !!drawer && drawer.dataset.marketCountry === 'AU';
  const currencyCode = (value) => {
    const code = typeof value === 'string' ? value : value && value.iso_code;
    return typeof code === 'string' && /^[A-Z]{3}$/.test(code) ? code : '';
  };
  let cartCurrency = currencyCode(drawer && drawer.dataset.cartCurrency);
  const cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  const cartUrl = (path) => cartRoot + path;
  const money = (cents) => cartCurrency
    ? new Intl.NumberFormat('en-US', { style: 'currency', currency: cartCurrency }).format((cents || 0) / 100)
    : isAustralia ? '' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  };
  const renderCart = (cart) => {
    cartCurrency = currencyCode(cart.currency) || cartCurrency;
    const auShippingEnabled = isAustralia && cartCurrency === 'AUD';
    const auCurrencyMismatch = isAustralia && !auShippingEnabled;
    if (drawer) drawer.dataset.auCurrencyMismatch = String(auCurrencyMismatch);
    const auShippingNote = drawer && drawer.querySelector('[data-au-shipping-note="drawer"]');
    if (auShippingNote) {
      auShippingNote.dataset.auCurrencyMismatch = String(auCurrencyMismatch);
      auShippingNote.textContent = (auShippingEnabled ? 'A$11 standard shipping. Free on orders A$92+ after discounts.' : 'Shipping options and charges are shown at checkout.') + '  Dispatch within 3 calendar days; delivery within 15 business days of placing the order.';
    }
    countNodes.forEach((node) => { node.textContent = cart.item_count || 0; });
    const isEmpty = !cart.items || !cart.items.length;
    if (footerNode) {
      footerNode.hidden = isEmpty;
      footerNode.style.display = isEmpty ? 'none' : '';
    }
    if (subtotalNode) subtotalNode.textContent = money(cart.total_price);
    const convertedShippingCountry = !!drawer && ["GB","CA","IT","ES","AT","PT","BE","NL","SE","DK","NO","AE","SA","QA","BH","JO","JP","IL","SG","NZ","IE","DE","FR","KW","CH","LU","FI","PL","CZ","SI","CY","MT","LT","RO","GR","HR","SK","EE","LV","HU","BG"].includes(drawer.dataset.marketCountry);
    const convertedShipping = convertedShippingCountry && window.FrilloraMarketShipping && window.FrilloraMarketShipping.snapshot(cartCurrency);
    const shippingUnavailable = (drawer && drawer.dataset.marketCountry === 'US' && cartCurrency !== 'USD') || auCurrencyMismatch || (convertedShippingCountry && !convertedShipping);
    const shippingThreshold = convertedShippingCountry ? (convertedShipping ? convertedShipping.threshold : 1) : freeShippingThreshold;
    if (convertedShippingCountry && window.FrilloraMarketShipping) window.FrilloraMarketShipping.render(cart.total_price, cartCurrency);
    const remaining = Math.max(0, shippingThreshold - (cart.total_price || 0));
    if (shippingText && !convertedShippingCountry) shippingText.textContent = shippingUnavailable ? 'Shipping options and charges are shown at checkout.'
      : auShippingEnabled ? (remaining === 0 ? 'Free standard shipping unlocked on orders A$92+ after discounts.' : money(remaining) + ' away from free standard shipping after discounts.')
      : remaining === 0 ? drawerLabels.freeShippingUnlocked : money(remaining) + ' ' + drawerLabels.freeShippingAway;
    const shippingProgress = ((cart.total_price || 0) / shippingThreshold) * 100;
    if (shippingBar) shippingBar.style.width = shippingUnavailable ? '0%' : Math.min(100, (auShippingEnabled || convertedShippingCountry) ? Math.floor(shippingProgress) : Math.round(shippingProgress)) + '%';
    if (!linesNode) return;
    if (isEmpty) {
      linesNode.innerHTML = window.FrilloraEmptyCartDrawer || '<div class="fr-drawer-empty"><p>Your bag is empty.</p><a class="fr-btn fr-btn--wide" href="' + escapeHtml(cartUrl('collections/all')) + '">Continue shopping</a></div>';
      return;
    }
    linesNode.innerHTML = cart.items.map((item) => {
      const title = escapeHtml(item.product_title);
      const variant = escapeHtml(item.variant_title || 'Default');
      const imageSrc = item.image ? item.image + '&width=160' : '';
      const image = imageSrc ? '<img src="' + escapeHtml(imageSrc) + '" alt="' + title + '">' : '';
      const key = escapeHtml(item.key || '');
      const qty = Number(item.quantity || 0);
      const quantityControl = '<div class="fr-cart-drawer__qty"><button type="button" data-cart-qty data-key="' + key + '" data-quantity="' + Math.max(0, qty - 1) + '" aria-label="' + escapeHtml(drawerLabels.qtyDecrease) + '">−</button><span>' + qty + '</span><button type="button" data-cart-qty data-key="' + key + '" data-quantity="' + (qty + 1) + '" aria-label="' + escapeHtml(drawerLabels.qtyIncrease) + '">+</button></div>';
      return '<div class="fr-cart-drawer__line">' + image + '<div><a href="' + item.url + '">' + title + '</a><small>' + variant + '</small>' + quantityControl + '</div><strong>' + money(item.final_line_price) + '</strong></div>';
    }).join('');
  };
  const refreshCart = async () => {
    const response = await fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async () => {
    openDrawer();
    try { await refreshCart(); } catch (error) {}
  }));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  overlay && overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });
  linesNode && linesNode.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-qty]');
    if (!button) return;
    button.disabled = true;
    try {
      const body = new URLSearchParams();
      body.set('id', button.dataset.key || '');
      body.set('quantity', button.dataset.quantity || '0');
      const response = await fetch(cartUrl('cart/change.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body,
      });
      renderCart(await response.json());
    } catch (error) {
      await refreshCart().catch(() => {});
    }
  });
  const frSilentCartPreview = 'FRILLORA-PDP-SILENT-CART-v1';
  const frSilentScope = form => form?.closest('.fr-pdp[data-fr-pdp-silent-cart-preview="true"]');
  const frSilentFeedback = new Map();
  const frSilentErrors = new Set();
  function frSilentStatus(scope, message, error = false) {
    const node = scope?.querySelector('[data-fr-pdp-silent-status]');
    if (!node) return;
    node.textContent = message || '';
    node.dataset.frSilentError = String(error && !!message);
    if(error&&message)frSilentErrors.add(scope);else frSilentErrors.delete(scope);
  }
  function frSilentReset(scope) {
    const previous = frSilentFeedback.get(scope);
    if (previous) {
      clearTimeout(previous.timer);
      previous.buttons.forEach(({button, children, label}) => {
        if (button.textContent === label) button.replaceChildren(...children);
      });
      frSilentFeedback.delete(scope);
    }
    frSilentStatus(scope, '');
  }
  function frSilentFinish(scope, message, success) {
    if (!scope) return;
    frSilentReset(scope);
    if (!success) { frSilentStatus(scope, message, true); return; }
    const label = (scope.dataset.frSilentAddedLabel || 'Added to Bag') + ' ✓';
    const buttons = [...scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]:not([name="return_to"])')]
      .filter(button => !button.disabled)
      .map(button => ({button, children: [...button.childNodes], label}));
    buttons.forEach(({button}) => { button.textContent = label; });
    frSilentStatus(scope, label);
    const timer = setTimeout(() => {
      if (frSilentFeedback.get(scope)?.timer !== timer) return;
      buttons.forEach(({button, children}) => { if (button.textContent === label) button.replaceChildren(...children); });
      frSilentFeedback.delete(scope);
      frSilentStatus(scope, '');
    }, 1800);
    frSilentFeedback.set(scope, {timer, buttons});
  }

  const frSilentFallback = new Map();
  window.FrilloraSilentPdpCartBlocked = scope => {
    const state=frSilentFallback.get(scope);
    return !!(state?.busy||state?.blocked);
  };
  async function frSilentReadCart() {
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),15000);
    try{
      const response = await fetch(cartUrl('cart.js'), {credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:'application/json'}});
      const fresh = await response.json();
      if (!response.ok || !fresh || !Array.isArray(fresh.items) || !Number.isFinite(fresh.item_count) || !Number.isFinite(fresh.total_price) || !/^[A-Z]{3}$/.test(fresh.currency)) throw Error('Your item may have been added. Open your bag and refresh before adding again.');
      renderCart(fresh);
      return fresh;
    }finally{clearTimeout(timeout);}
  }
  async function frSilentFallbackSubmit(scope, form, event) {
    event.preventDefault();event.stopImmediatePropagation();
    const previous = frSilentFallback.get(scope);
    if (previous?.busy) return;
    if (previous?.blocked) {frSilentStatus(scope, previous.message, true);return;}
    const data = new FormData(form);
    const state = {busy:true,blocked:false,message:''};
    frSilentFallback.set(scope,state);
    frSilentReset(scope);
    const controls = [...scope.querySelectorAll('form[action*="/cart/add"] button,form[action*="/cart/add"] input:not([type="hidden"]),form[action*="/cart/add"] select,[data-product-option-button]')]
      .map(node=>({node,disabled:node.disabled,children:[...node.childNodes],ariaBusy:node.getAttribute('aria-busy')}));
    controls.forEach(({node})=>{node.disabled=true;if(node.matches('button[type="submit"]:not([name="return_to"])')){node.textContent='Adding…';node.setAttribute('aria-busy','true');}});
    frSilentStatus(scope,'Adding…');
    let acknowledged=false,confirmed=false,errorMessage='';
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),15000);
    try {
      const response=await fetch(cartUrl('cart/add.js'),{method:'POST',credentials:'same-origin',body:data,signal:controller.signal,headers:{Accept:'application/json'}});
      let result;
      try{result=await response.json();}catch{throw Error('We could not confirm the last change. Open your bag and review it before adding again.');}
      confirmed=!response.ok&&response.status>=400&&response.status<500&&response.status!==408&&response.status!==429&&Number(result?.status||response.status)<500;
      if(!response.ok)throw Error(typeof result?.description==='string'?result.description:'This item could not be added.');
      if(!result||typeof result!=='object'||(!Array.isArray(result)&&!result.id&&!Array.isArray(result.items)))throw Error('We could not confirm the last change. Open your bag and review it before adding again.');
      acknowledged=true;
      await frSilentReadCart();
    } catch(error) {
      errorMessage=error.message||'This item could not be added.';
      state.blocked=acknowledged||!confirmed;
      state.message=state.blocked?(acknowledged?'Your item was added. Open your bag and refresh before adding again.':'We could not confirm the last change. Open your bag and review it before adding again.'):errorMessage;
      errorMessage=state.message;
    } finally {
      clearTimeout(timeout);
      state.busy=false;
      controls.forEach(({node,disabled,children,ariaBusy})=>{node.disabled=state.blocked||disabled;node.replaceChildren(...children);if(ariaBusy===null)node.removeAttribute('aria-busy');else node.setAttribute('aria-busy',ariaBusy);});
      if(!state.blocked)try{window.FrilloraSyncPdpPurchaseState?.();}catch{}
      frSilentFinish(scope,errorMessage,acknowledged&&!errorMessage);
    }
  }
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      if (submitter && submitter.name === 'return_to') return;
      const silentScope = frSilentScope(form);
      if (silentScope) return frSilentFallbackSubmit(silentScope, form, event);
      event.preventDefault();
      const button = submitter || form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      try {
        await fetch(cartUrl('cart/add.js'), { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        await refreshCart();
        openDrawer();
      } catch (error) {
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    });
  });
  document.querySelectorAll('[data-cart-page-qty]').forEach((control) => {
    const input = control.querySelector('[data-cart-page-input]');
    const minus = control.querySelector('[data-cart-page-minus]');
    const plus = control.querySelector('[data-cart-page-plus]');
    const setValue = (next) => {
      if (!input) return;
      input.value = String(Math.max(0, Number(next || 0)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    minus && minus.addEventListener('click', () => setValue(Number(input.value || 0) - 1));
    plus && plus.addEventListener('click', () => setValue(Number(input.value || 0) + 1));
  });
  document.querySelectorAll('[data-pdp-quantity]').forEach((control) => {
    const input = control.querySelector('[data-pdp-quantity-input]');
    const minus = control.querySelector('[data-pdp-quantity-minus]');
    const plus = control.querySelector('[data-pdp-quantity-plus]');
    const setValue = (next) => {
      if (!input) return;
      input.value = String(Math.max(1, Number(next || 1)));
    };
    minus && minus.addEventListener('click', () => setValue(Number(input.value || 1) - 1));
    plus && plus.addEventListener('click', () => setValue(Number(input.value || 1) + 1));
    input && input.addEventListener('change', () => setValue(input.value));
  });
  refreshCart().catch(() => {});
})();

(() => {
  if (!document.querySelector('[data-filter-panel]')) return;
  let stickyOffsetFrame = 0;
  const updateCollectionStickyOffset = () => {
    if (stickyOffsetFrame) return;
    stickyOffsetFrame = window.requestAnimationFrame(() => {
      stickyOffsetFrame = 0;
      const header = document.querySelector('.fr-header');
      const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      const visibleHeaderBottom = Math.max(0, Math.min(window.innerHeight, headerBottom));
      document.documentElement.style.setProperty('--fr-filter-sticky-top', `${Math.round(visibleHeaderBottom)}px`);
    });
  };
  updateCollectionStickyOffset();
  window.addEventListener('scroll', updateCollectionStickyOffset, { passive: true });
  window.addEventListener('resize', updateCollectionStickyOffset, { passive: true });
  document.addEventListener('shopify:section:load', updateCollectionStickyOffset);
})();

(() => {
  const grid = document.querySelector('[data-product-grid]');
  if (!grid) return;
  const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
  const filterButtons = Array.from(document.querySelectorAll('[data-filter-value]'));
  const clearButtons = Array.from(document.querySelectorAll('[data-filter-clear]'));
  const countNode = document.querySelector('[data-product-count]');
  const emptyNode = document.querySelector('[data-empty-state]');
  const sortSelect = document.querySelector('[data-sort-products]');
  const active = new Set();
  const resultsAnchor = document.querySelector('.fr-collection-toolbar') || grid;
  const shouldRestoreMobileResults = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return false;
    const filterPanel = document.querySelector('[data-filter-panel]');
    if (!filterPanel || window.getComputedStyle(filterPanel).position !== 'sticky') return false;
    const anchorTop = resultsAnchor.getBoundingClientRect().top + window.scrollY;
    return window.scrollY > anchorTop;
  };
  const restoreMobileResults = () => {
    window.requestAnimationFrame(() => {
      const filterPanel = document.querySelector('[data-filter-panel]');
      const filterStyle = filterPanel ? window.getComputedStyle(filterPanel) : null;
      const stickyTop = filterStyle && filterStyle.position === 'sticky' ? Number.parseFloat(filterStyle.top) || 0 : 0;
      const stickyHeight = filterPanel ? filterPanel.getBoundingClientRect().height : 0;
      const anchorTop = resultsAnchor.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: Math.max(0, anchorTop - stickyTop - stickyHeight - 12), behavior: 'auto' });
    });
  };
  const optionWouldMatch = (value) => cards.some((card) => {
    const tags = (card.dataset.tags || '').split(',').map((tag) => tag.trim());
    const nextActive = new Set(active);
    nextActive.add(value);
    return Array.from(nextActive).every((activeValue) => tags.includes(activeValue));
  });
  const syncFilterAvailability = () => {
    filterButtons.forEach((button) => {
      const value = button.dataset.filterKey || button.dataset.filterValue;
      const isActive = active.has(value);
      const isAvailable = isActive || optionWouldMatch(value);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.hidden = !isAvailable;
      button.disabled = !isAvailable;
    });
    document.querySelectorAll('.fr-filters details').forEach((group) => {
      const visibleButtons = Array.from(group.querySelectorAll('[data-filter-value]')).some((button) => !button.hidden);
      group.hidden = !visibleButtons;
    });
  };
  const apply = (preserveMobileResults = false) => {
    const restoreResults = preserveMobileResults && shouldRestoreMobileResults();
    let shown = 0;
    cards.forEach((card) => {
      const tags = (card.dataset.tags || '').split(',').map((tag) => tag.trim());
      const matches = active.size === 0 || Array.from(active).every((value) => tags.includes(value));
      card.hidden = !matches;
      card.style.display = matches ? '' : 'none';
      if (matches) shown += 1;
    });
    if (countNode) countNode.textContent = String(shown);
    if (emptyNode) emptyNode.hidden = shown !== 0;
    syncFilterAvailability();
    if (restoreResults) restoreMobileResults();
  };
  const sortCards = () => {
    const mode = sortSelect ? sortSelect.value : 'manual';
    const sorted = cards.slice().sort((a, b) => {
      if (mode === 'price-asc') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
      if (mode === 'price-desc') return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
      if (mode === 'savings') return Number(b.dataset.savings || 0) - Number(a.dataset.savings || 0);
      return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
    });
    sorted.forEach((card) => grid.appendChild(card));
  };
  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const value = button.dataset.filterKey || button.dataset.filterValue;
      if (!value) return;
      if (active.has(value)) active.delete(value); else active.add(value);
      filterButtons.filter((other) => (other.dataset.filterKey || other.dataset.filterValue) === value).forEach((other) => {
        const isActive = active.has(value);
        other.classList.toggle('is-active', isActive);
        other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      apply(true);
    });
  });
  clearButtons.forEach((clearButton) => clearButton.addEventListener('click', () => {
    active.clear();
    filterButtons.forEach((button) => {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });
    apply(true);
  }));
  sortSelect && sortSelect.addEventListener('change', () => { sortCards(); apply(); });
  sortCards();
  apply();
})();
(() => {
  const activateSwatch = (button) => {
    const card = button && button.closest('[data-product-card]');
    if (!card) return;
    const image = card.querySelector('[data-card-image]');
    const variantInput = card.querySelector('input[data-card-variant-id]');
    const nextSrc = button.dataset.cardImageSrc;
    const nextSrcset = button.dataset.cardImageSrcset;
    if (image && nextSrc && image.getAttribute('src') !== nextSrc) {
      image.src = nextSrc;
      if (nextSrcset) image.setAttribute('srcset', nextSrcset); else image.removeAttribute('srcset');
      image.loading = 'eager';
      if (button.dataset.cardImageAlt) image.setAttribute('alt', button.dataset.cardImageAlt);
    }
    if (variantInput && button.dataset.cardVariantId) variantInput.value = button.dataset.cardVariantId;
    frSyncCardVariantPrice(card, button.dataset);
    frSyncCollectionCardLinks(card, button.dataset.cardVariantId);
    card.querySelectorAll('[data-card-swatch]').forEach((swatch) => {
      const selected = swatch === button;
      swatch.classList.toggle('is-active', selected);
      swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-swatch]');
    if (!button) return;
    event.preventDefault();
    activateSwatch(button);
  });
  document.addEventListener('pointerenter', (event) => {
    const button = event.target.closest && event.target.closest('[data-card-swatch]');
    if (button) activateSwatch(button);
  }, true);
  document.addEventListener('focusin', (event) => {
    const button = event.target.closest && event.target.closest('[data-card-swatch]');
    if (button) activateSwatch(button);
  });
  document.querySelectorAll('[data-card-swatch].is-active').forEach(activateSwatch);
})();

(() => {
  document.querySelectorAll('[data-pdp-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const image = document.querySelector('[data-pdp-main-image]');
      const nextSrc = button.dataset.pdpImageSrc;
      if (!image || !nextSrc) return;
      window.FrilloraPerformanceMedia.set(image, nextSrc, button.dataset.pdpImageAlt);
      button.closest('.fr-pdp-thumbs').querySelectorAll('[data-pdp-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
    });
  });
})();
(() => {
  document.querySelectorAll('.fr-pdp-card').forEach((scope) => {
    const variantsNode = scope.querySelector('[data-product-variants]');
    const variantInput = scope.querySelector('[data-product-variant-id]');
    const stickyVariant = document.querySelector('[data-sticky-variant]');
    if (!variantsNode || !variantInput) return;
    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      return;
    }
    const buttons = Array.from(scope.querySelectorAll('[data-product-option-button]'));
    const selected = {};
    buttons.forEach((button) => {
      if (button.classList.contains('is-active')) selected[button.dataset.optionPosition] = button.dataset.optionValue;
    });
    const setMainImage = (src, alt) => {
      const image = document.querySelector('[data-pdp-main-image]');
      if (!image || !src) return;
      window.FrilloraPerformanceMedia.set(image, src, alt);
    };
    const formatMoney = (cents, format) => {
      const value = Number(cents);
      if (!Number.isFinite(value)) return '';
      const template = format || '${{amount}}';
      const token = (template.match(/{{\s*(\w+)\s*}}/) || [])[1] || 'amount';
      const decimalPlaces = token.includes('no_decimals') ? 0 : 2;
      const decimal = token.includes('comma_separator') ? ',' : '.';
      const thousands = token.includes('comma_separator') ? '.' : ',';
      const fixed = (value / 100).toFixed(decimalPlaces);
      const parts = fixed.split('.');
      const grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const amount = decimalPlaces ? grouped + decimal + parts[1] : grouped;
      return template.replace(/{{\s*\w+\s*}}/, amount);
    };
    const updatePdpPrice = (variant) => {
      if (!variant || !Number.isFinite(Number(variant.price))) return;
      const wrapper = scope.querySelector('[data-product-price]');
      if (!wrapper) return;
      const moneyFormat = wrapper.dataset.moneyFormat || '${{amount}}';
      const current = wrapper.querySelector('[data-product-price-current]');
      const compare = wrapper.querySelector('[data-product-price-compare]');
      const savings = wrapper.querySelector('[data-product-price-savings]');
      const badge = document.querySelector('[data-pdp-savings-badge]');
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const compareAt = Number(variant.compare_at_price || 0);
      const price = Number(variant.price);
      const hasSavings = Number.isFinite(compareAt) && compareAt > price;
      const savePercent = hasSavings ? Math.round(((compareAt - price) * 100) / compareAt) : 0;
      const savePrefix = wrapper.dataset.savePrefix || 'Save';
      if (current) current.textContent = formatMoney(price, moneyFormat);
      if (compare) {
        compare.hidden = !hasSavings;
        if (hasSavings) compare.textContent = formatMoney(compareAt, moneyFormat);
      }
      if (savings) {
        savings.hidden = !hasSavings;
        savings.textContent = hasSavings ? savePrefix + ' ' + savePercent + '%' : '';
      }
      if (badge) {
        badge.hidden = !hasSavings;
        if (hasSavings) badge.textContent = savePrefix + ' ' + savePercent + '%';
      }
      if (stickyPrice) stickyPrice.textContent = hasSavings
        ? formatMoney(price, moneyFormat) + ' · ' + savePrefix + ' ' + savePercent + '%'
        : formatMoney(price, moneyFormat);
    };
    const updateLabels = () => {
      scope.querySelectorAll('[data-selected-option-label]').forEach((label) => {
        const value = selected[label.dataset.selectedOptionLabel];
        const activeButton = buttons.find((button) => button.dataset.optionPosition === label.dataset.selectedOptionLabel && button.dataset.optionValue === value);
        if (value) label.textContent = activeButton?.dataset.optionLabel || value;
      });
    };
    const findVariant = () => variants.find((variant) => variant.options.every((option, index) => {
      const currentPosition = String(index + 1);
      return !selected[currentPosition] || selected[currentPosition] === option;
    }));
    const optionGloballyAvailable = (position, value) => variants.some((variant) => variant.available && variant.options[Number(position) - 1] === value);
    const optionAvailableWithCurrentSelection = (position, value) => variants.some((variant) => {
      if (!variant.available || variant.options[Number(position) - 1] !== value) return false;
      return variant.options.every((option, index) => {
        const currentPosition = String(index + 1);
        if (currentPosition === String(position)) return true;
        return !selected[currentPosition] || selected[currentPosition] === option;
      });
    });
    const shouldDisableButton = (button) => {
      const position = button.dataset.optionPosition;
      const value = button.dataset.optionValue;
      if (button.closest('.fr-pdp-swatches') || button.dataset.optionRole === 'generic') return !optionGloballyAvailable(position, value);
      return !optionAvailableWithCurrentSelection(position, value);
    };
    const applyVariantSelection = (variant) => {
      if (!variant) return;
      variant.options.forEach((option, index) => {
        selected[String(index + 1)] = option;
      });
    };
    const syncButtons = () => {
      buttons.forEach((button) => {
        const disabled = shouldDisableButton(button);
        button.disabled = disabled;
        button.classList.toggle('is-disabled', disabled);
        button.classList.toggle('is-active', selected[button.dataset.optionPosition] === button.dataset.optionValue);
        button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
        const soldOut = button.querySelector('[data-option-sold-out]');
        if (soldOut) soldOut.hidden = !disabled;
      });
    };
    const syncPdpVariantUrl = (variantId) => {
      if (window.__frCartPdpEmbed || !variantId || !window.history?.replaceState) return;
      try {
        const url = new URL(document.baseURI);
        url.searchParams.set('variant', String(variantId));
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (error) {
        // URL synchronization must never block variant selection or purchase actions.
      }
    };
    const sync = (preferredPosition, preferredValue, imageButton) => {
      let variant = findVariant();
      if ((!variant || !variant.available) && preferredPosition && preferredValue) {
        variant = variants.find((candidate) => candidate.available && candidate.options[Number(preferredPosition) - 1] === preferredValue) || variant;
      }
      if (!variant || !variant.available) variant = variants.find((candidate) => candidate.available) || variant;
      applyVariantSelection(variant);
      syncButtons();
      if (variant) {
        variantInput.value = variant.id;
        if (stickyVariant) stickyVariant.value = variant.id;
        updatePdpPrice(variant);
        if (preferredPosition && preferredValue) syncPdpVariantUrl(variant.id);
      }
      const activeImageButton = buttons.find((button) => button.classList.contains('is-active') && button.dataset.pdpImageSrc);
      if (imageButton && imageButton.classList.contains('is-active')) {
        setMainImage(imageButton.dataset.pdpImageSrc, imageButton.dataset.pdpImageAlt);
      } else if (activeImageButton && (preferredPosition || !scope.closest('[data-fr-initial-product-cover="true"]'))) {
        setMainImage(activeImageButton.dataset.pdpImageSrc, activeImageButton.dataset.pdpImageAlt);
      }
      updateLabels();
    };
    // FRILLORA-COLOR-PACK-ATOMIC-v1: only existing variant IDs enter native state.
    scope.addEventListener('fr:select-variant', (event) => {
      const detail = event.detail || {};
      const variant = variants.find((item) => String(item.id) === String(detail.variantId));
      if (!variant || (!variant.available && !detail.allowUnavailable)) return;
      applyVariantSelection(variant);
      syncButtons();
      variantInput.value = variant.id;
      if (stickyVariant) stickyVariant.value = variant.id;
      updatePdpPrice(variant);
      updateLabels();
      if (detail.updateUrl !== false) syncPdpVariantUrl(variant.id);
      detail.applied = true;
      scope.dispatchEvent(new CustomEvent('fr:variant-selected', {bubbles:true,detail:{variantId:String(variant.id),reason:detail.reason || 'color-pack'}}));
      variantInput.dispatchEvent(new Event('change', {bubbles:true}));
      window.FrilloraSyncPdpPurchaseState?.();
    });
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const position = button.dataset.optionPosition;
        selected[position] = button.dataset.optionValue;
        sync(position, button.dataset.optionValue, button);
      });
    });
    scope.querySelectorAll('[data-variant-direct]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        variantInput.value = button.dataset.variantDirect;
        if (stickyVariant) stickyVariant.value = button.dataset.variantDirect;
        const directVariant = variants.find((variant) => String(variant.id) === String(button.dataset.variantDirect));
        updatePdpPrice(directVariant);
        if (directVariant) syncPdpVariantUrl(directVariant.id);
        scope.querySelectorAll('[data-variant-direct]').forEach((other) => other.classList.toggle('is-active', other === button));
      });
    });
    const frColorPackInitialId = window.__frColorPackInitialVariant || new URL(document.baseURI).searchParams.get('variant');
    const frColorPackInitialVariant = scope.querySelector('[data-fr-color-pack-widget]') && variants.find((item) => String(item.id) === String(frColorPackInitialId));
    if (frColorPackInitialVariant) {
      scope.dispatchEvent(new CustomEvent('fr:select-variant', {detail:{variantId:String(frColorPackInitialVariant.id),allowUnavailable:true,updateUrl:false,reason:'initial'}}));
    } else sync();
  });
})();

(() => {
  const linesNode = document.querySelector('[data-cart-lines]');
  if (!linesNode) return;
  const emptyTemplate = document.querySelector('[data-cart-drawer-empty-template]');
  if (emptyTemplate) window.FrilloraEmptyCartDrawer = emptyTemplate.innerHTML;
})();

(() => {
  const controllers = new WeakMap();
  const initialize = (slider) => {
    if (controllers.has(slider)) return;
    const track = slider.querySelector('.fr-hero__slides');
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
    if (!track || slides.length <= 1) return;
    const controller = new AbortController();
    const listen = (node, type, handler, options = {}) => node.addEventListener(type, handler, { ...options, signal: controller.signal });
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let start = null;
    let wheelTimer = null;
    const show = (next) => {
      index = ((next % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      track.style.transform = 'translate3d(' + (-100 * index) + '%,0,0)';
    };
    const endSwipe = (point) => {
      if (!start || !point) { start = null; return; }
      const dx = point.clientX - start.clientX;
      const dy = point.clientY - start.clientY;
      start = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.25) show(index + (dx < 0 ? 1 : -1));
    };
    dots.forEach((dot, i) => listen(dot, 'click', () => show(i)));
    listen(slider, 'pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      start = { clientX: event.clientX, clientY: event.clientY };
    }, { passive: true });
    listen(slider, 'pointerup', (event) => {
      if (event.pointerType !== 'touch') endSwipe(event);
    }, { passive: true });
    listen(slider, 'pointercancel', () => { start = null; }, { passive: true });
    listen(slider, 'touchstart', (event) => {
      const point = event.touches.length === 1 ? event.touches[0] : null;
      start = point ? { clientX: point.clientX, clientY: point.clientY } : null;
    }, { passive: true });
    listen(slider, 'touchmove', (event) => {
      if (!start || event.touches.length !== 1) { start = null; return; }
      const point = event.touches[0];
      const dx = point.clientX - start.clientX;
      const dy = point.clientY - start.clientY;
      if (Math.abs(dx) > 24 && Math.abs(dx) > Math.abs(dy) * 1.25) event.preventDefault();
    }, { passive: false });
    listen(slider, 'touchend', (event) => endSwipe(event.changedTouches[0]), { passive: true });
    listen(slider, 'touchcancel', () => { start = null; }, { passive: true });
    listen(slider, 'wheel', (event) => {
      if (Math.abs(event.deltaX) < 18 || Math.abs(event.deltaX) < Math.abs(event.deltaY) * 1.15) return;
      event.preventDefault();
      if (wheelTimer !== null) return;
      show(index + (event.deltaX > 0 ? 1 : -1));
      wheelTimer = window.setTimeout(() => { wheelTimer = null; }, 560);
    }, { passive: false });
    const interval = Number(slider.dataset.heroInterval || 6500);
    const timer = interval > 0 ? window.setInterval(() => show(index + 1), interval) : null;
    controllers.set(slider, () => {
      controller.abort();
      if (timer !== null) window.clearInterval(timer);
      if (wheelTimer !== null) window.clearTimeout(wheelTimer);
      controllers.delete(slider);
    });
    show(index);
  };
  const visit = (scope, callback) => {
    if (scope.matches?.('[data-hero-slider]')) callback(scope);
    scope.querySelectorAll('[data-hero-slider]').forEach(callback);
  };
  visit(document, initialize);
  document.addEventListener('shopify:section:load', (event) => visit(event.target, initialize));
  document.addEventListener('shopify:section:unload', (event) => visit(event.target, (slider) => controllers.get(slider)?.()));
})();



(() => {
  const backdrop = document.querySelector('[data-filter-backdrop]');
  const panel = document.querySelector('[data-filter-panel]');
  if (!backdrop) return;
  const syncBackdrop = () => {
    const open = Boolean(panel && panel.classList.contains('is-open') && document.documentElement.classList.contains('fr-filter-lock'));
    backdrop.hidden = !open;
    backdrop.classList.toggle('is-open', open);
  };
  syncBackdrop();
  new MutationObserver(syncBackdrop).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  if (panel) new MutationObserver(syncBackdrop).observe(panel, { attributes: true, attributeFilter: ['class'] });
})();

(() => {
  const fadeImage = (image, nextSrc, nextAlt, nextSrcset) => {
    if (!image || !nextSrc || image.getAttribute('src') === nextSrc) return;
    image.style.opacity = '.42';
    const restore = () => { image.style.opacity = ''; image.removeEventListener('load', restore); };
    image.addEventListener('load', restore);
    image.src = nextSrc;
    if (nextSrcset) image.setAttribute('srcset', nextSrcset); else image.removeAttribute('srcset');
    if (nextAlt) image.setAttribute('alt', nextAlt);
    window.setTimeout(restore, 260);
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-swatch]');
    if (!button) return;
    const card = button.closest('[data-product-card]');
    fadeImage(card && card.querySelector('[data-card-image]'), button.dataset.cardImageSrc, button.dataset.cardImageAlt, button.dataset.cardImageSrcset);
  }, true);
  document.addEventListener('pointerenter', (event) => {
    const button = event.target.closest && event.target.closest('[data-card-swatch]');
    if (!button) return;
    const card = button.closest('[data-product-card]');
    fadeImage(card && card.querySelector('[data-card-image]'), button.dataset.cardImageSrc, button.dataset.cardImageAlt, button.dataset.cardImageSrcset);
  }, true);
})();

(() => {
  const root = document.querySelector('.fr-page-customizer .fr-customizer');
  if (!root) return;
  const topbar = root.querySelector('.fr-customizer__topbar');
  const mobileQuery = window.matchMedia('(max-width: 620px)');
  const syncNav = () => {
    if (!mobileQuery.matches) {
      root.classList.remove('fr-customizer--nav-fixed');
      return;
    }
    const trigger = topbar ? topbar.offsetHeight : 0;
    root.classList.toggle('fr-customizer--nav-fixed', window.scrollY > trigger);
  };
  window.addEventListener('scroll', syncNav, { passive: true });
  window.addEventListener('resize', syncNav);
  mobileQuery.addEventListener?.('change', syncNav);
  syncNav();
})();

(() => {
  const init = () => {
    const sticky = document.querySelector('.fr-page-customizer [data-customizer-sticky]');
    if (!sticky) return;
    const reveal = () => {
      sticky.hidden = false;
      sticky.removeAttribute('hidden');
    };
    reveal();
    window.addEventListener('load', reveal);
    setTimeout(reveal, 0);
    setTimeout(reveal, 400);
    setTimeout(reveal, 1200);
    window.addEventListener('scroll', () => setTimeout(reveal, 0), { passive: true });
    window.addEventListener('resize', reveal);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(() => {
  const activateCardSwatch = (button) => {
    const card = button && button.closest('[data-product-card]');
    if (!card) return;
    const image = card.querySelector('[data-card-image]');
    const variantInput = card.querySelector('input[data-card-variant-id]');
    const nextSrc = button.dataset.cardImageSrc;
    const nextSrcset = button.dataset.cardImageSrcset;
    if (image && nextSrc) {
      const absoluteNext = new URL(nextSrc, document.baseURI).href;
      if (image.src !== absoluteNext) {
        image.src = nextSrc;
        if (nextSrcset) image.setAttribute('srcset', nextSrcset); else image.removeAttribute('srcset');
        image.loading = 'eager';
      }
      if (button.dataset.cardImageAlt) image.setAttribute('alt', button.dataset.cardImageAlt);
    }
    if (variantInput && button.dataset.cardVariantId) variantInput.value = button.dataset.cardVariantId;
    frSyncCardVariantPrice(card, button.dataset);
    frSyncCollectionCardLinks(card, button.dataset.cardVariantId);
    card.querySelectorAll('[data-card-swatch]').forEach((swatch) => {
      const selected = swatch === button;
      swatch.classList.toggle('is-active', selected);
      swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };
  const handleCardSwatch = (event) => {
    const button = event.target.closest && event.target.closest('[data-card-swatch]');
    if (!button) return;
    activateCardSwatch(button);
    if (event.type === 'click') {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  document.addEventListener('pointerdown', handleCardSwatch, true);
  document.addEventListener('click', handleCardSwatch, true);
  document.querySelectorAll('[data-card-swatch]').forEach((button) => {
    button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
  });
  const markPdpChoice = (button) => {
    const scope = button && button.closest('.fr-pdp-card');
    if (!scope || button.disabled) return;
    const position = button.dataset.optionPosition;
    if (!position) return;
    scope.querySelectorAll('[data-product-option-button]').forEach((other) => {
      if (other.dataset.optionPosition === position) {
        const selected = other === button;
        other.classList.toggle('is-active', selected);
        other.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }
    });
    const label = scope.querySelector('[data-selected-option-label="' + position + '"]');
    if (label && button.dataset.optionValue) label.textContent = button.dataset.optionLabel || button.dataset.optionValue;
  };
  const handlePdpChoice = (event) => {
    const button = event.target.closest && event.target.closest('[data-product-option-button]');
    if (!button || !button.closest('.fr-pdp-swatches')) return;
    markPdpChoice(button);
  };
  document.addEventListener('click', handlePdpChoice);
  document.querySelectorAll('.fr-pdp-swatches [data-product-option-button]').forEach((button) => {
    button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
  });
})();





(() => {
  const cardSwatchKey = (button) => {
    const explicit = button.dataset.cardSwatchKey || '';
    if (explicit.trim()) return explicit.trim();
    const dot = button.querySelector('.fr-color-dot');
    const swatch = dot && (dot.style.getPropertyValue('--sw') || dot.getAttribute('style') || '');
    return String(swatch || '').replace(/\s+/g, ' ').trim();
  };
  const normalizeCardSwatches = (card) => {
    const buttons = Array.from(card.querySelectorAll('[data-card-swatch]'));
    if (buttons.length < 2) return;
    const seen = new Map();
    buttons.forEach((button) => {
      const key = cardSwatchKey(button);
      if (!key) return;
      button.dataset.cardSwatchKey = key;
      const existing = seen.get(key);
      if (!existing) {
        seen.set(key, button);
        return;
      }
      if (button.classList.contains('is-active')) {
        existing.classList.add('is-active');
        existing.setAttribute('aria-pressed', 'true');
      }
      button.remove();
    });
    const remaining = Array.from(card.querySelectorAll('[data-card-swatch]'));
    if (remaining.length && !remaining.some((button) => button.classList.contains('is-active'))) {
      remaining[0].classList.add('is-active');
      remaining[0].setAttribute('aria-pressed', 'true');
    }
  };
  const normalizeAllCards = () => {
    document.querySelectorAll('[data-product-card]').forEach(normalizeCardSwatches);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeAllCards);
  } else {
    normalizeAllCards();
  }
  window.addEventListener('load', normalizeAllCards);
  setTimeout(normalizeAllCards, 0);
  setTimeout(normalizeAllCards, 600);
})();

(() => {
  const cleanUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, document.baseURI);
      const path = url.pathname.replace(/_(?:\d+x\d*|\d+x|x\d+)(?=\.)/i, '');
      return (url.origin + path).toLowerCase();
    } catch (error) {
      return String(value).split('?')[0].replace(/_(?:\d+x\d*|\d+x|x\d+)(?=\.)/i, '').toLowerCase();
    }
  };
  const sizedUrl = (value, width) => {
    if (!value) return '';
    try {
      const url = new URL(value, document.baseURI);
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (error) {
      return value;
    }
  };
  const setImage = (image, src, alt, srcset = '') => {
    if (!image || !src) return;
    if (image.hasAttribute('data-pdp-main-image')) {
      window.FrilloraPerformanceMedia.set(image, src, alt);
      return;
    }
    const absoluteNext = new URL(src, document.baseURI).href;
    if (image.src !== absoluteNext) {
      image.src = src;
      if (srcset) image.setAttribute('srcset', srcset); else image.removeAttribute('srcset');
      image.loading = 'eager';
    }
    if (alt) image.setAttribute('alt', alt);
  };
  const variantImage = (variant) => {
    if (!variant) return null;
    const raw = variant.featured_image || variant.featuredImage || variant.image || variant.featured_media?.preview_image || variant.featured_media?.image;
    if (!raw) return null;
    if (typeof raw === 'string') return { id: '', src: raw, alt: variant.public_title || variant.title || '' };
    const src = raw.src || raw.url || raw.originalSrc || raw.transformedSrc || raw.preview_image?.src;
    if (!src) return null;
    return {
      id: raw.id ? String(raw.id) : (raw.media_id ? String(raw.media_id) : ''),
      src,
      alt: raw.alt || variant.public_title || variant.title || '',
    };
  };
  const activatePdpThumb = (button) => {
    if (!button || !button.dataset.pdpImageSrc) return;
    const gallery = button.closest('[data-pdp-gallery]') || document.querySelector('[data-pdp-gallery]');
    const image = gallery?.querySelector('[data-pdp-main-image]') || document.querySelector('[data-pdp-main-image]');
    setImage(image, button.dataset.pdpImageSrc, button.dataset.pdpImageAlt);
    const thumbs = button.closest('.fr-pdp-thumbs') || gallery?.querySelector('.fr-pdp-thumbs');
    thumbs?.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
      const selected = thumb === button;
      thumb.classList.toggle('is-active', selected);
      thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };
  const findMatchingProductThumb = (thumbs, image) => {
    if (!thumbs || !image) return null;
    const imageId = image.id ? String(image.id) : '';
    const normalized = cleanUrl(image.src);
    return Array.from(thumbs.querySelectorAll('[data-pdp-product-thumb]')).find((thumb) => {
      if (imageId && thumb.dataset.pdpMediaId && String(thumb.dataset.pdpMediaId) === imageId) return true;
      return normalized && cleanUrl(thumb.dataset.pdpImageSrc) === normalized;
    }) || null;
  };
  const updateVariantThumb = (gallery, variant, jumpToVariant) => {
    const thumbs = gallery?.querySelector('.fr-pdp-thumbs');
    if (!thumbs) return;
    const image = variantImage(variant);
    let variantThumb = thumbs.querySelector('[data-pdp-variant-thumb]');
    if (!image) {
      variantThumb?.remove();
      return;
    }
    const matchingProductThumb = findMatchingProductThumb(thumbs, image);
    if (matchingProductThumb) {
      variantThumb?.remove();
      if (jumpToVariant) activatePdpThumb(matchingProductThumb);
      return;
    }
    if (!variantThumb) {
      variantThumb = document.createElement('button');
      variantThumb.type = 'button';
      variantThumb.className = 'fr-pdp-thumb fr-pdp-thumb--variant';
      variantThumb.setAttribute('data-pdp-thumb', '');
      variantThumb.setAttribute('data-pdp-variant-thumb', '');
      variantThumb.setAttribute('aria-label', 'Show selected variant image');
      const img = document.createElement('img');
      img.loading = 'lazy';
      img.width = 160;
      img.height = 160;
      variantThumb.appendChild(img);
      thumbs.appendChild(variantThumb);
    }
    const alt = image.alt || variant?.public_title || variant?.title || 'Selected variant image';
    variantThumb.dataset.pdpMediaId = image.id || '';
    variantThumb.dataset.pdpImageSrc = sizedUrl(image.src, 1400);
    variantThumb.dataset.pdpImageAlt = alt;
    const thumbImg = variantThumb.querySelector('img');
    if (thumbImg) setImage(thumbImg, sizedUrl(image.src, 260), alt);
    if (jumpToVariant) activatePdpThumb(variantThumb);
  };
  const selectedVariantForScope = (scope) => {
    const variantsNode = scope?.querySelector('[data-product-variants]');
    const variantInput = scope?.querySelector('[data-product-variant-id]');
    if (!variantsNode) return null;
    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      return null;
    }
    const selectedId = variantInput?.value ? String(variantInput.value) : '';
    return variants.find((variant) => String(variant.id) === selectedId) || variants.find((variant) => variant.available) || variants[0] || null;
  };
  const bindRetainedMingyanCover = (gallery) => {
    const frame = gallery?.querySelector('[data-fr-retained-product-cover]');
    const main = gallery?.querySelector('[data-pdp-main-image]');
    const cover = frame?.querySelector('img');
    if (!frame || !main || !cover || frame.dataset.frCoverBound === 'true') return;
    frame.dataset.frCoverBound = 'true';
    const coverUrl = cleanUrl(cover.getAttribute('src'));
    const sync = () => {
      const visible = cleanUrl(main.getAttribute('src')) !== coverUrl;
      frame.hidden = !visible;
      if (visible) frame.style.removeProperty('display');
      else frame.style.setProperty('display', 'none', 'important');
    };
    new MutationObserver(sync).observe(main, { attributes: true, attributeFilter: ['src'] });
    sync();
  };
  const syncPdp = (scope, jumpToVariant = false) => {
    const gallery = document.querySelector('[data-pdp-gallery]');
    const variant = selectedVariantForScope(scope);
    bindRetainedMingyanCover(gallery);
    updateVariantThumb(gallery, variant, jumpToVariant);
    document.querySelectorAll('[data-sticky-variant]').forEach((input) => {
      const variantInput = scope?.querySelector('[data-product-variant-id]');
      if (variantInput?.value) input.value = variantInput.value;
    });
  };
  document.addEventListener('fr:variant-selected', (event) => {
    const scope = event.target.closest('.fr-pdp-card');
    if (scope) syncPdp(scope, event.detail?.reason !== 'initial' || !scope.closest('[data-fr-initial-product-cover="true"]'));
  });
  const resetPdpToProductMain = () => {
    const gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;
    const firstProductThumb = gallery.querySelector('[data-pdp-product-thumb]');
    if (firstProductThumb) activatePdpThumb(firstProductThumb);
  };
  const initPdp = () => {
    const scope = document.querySelector('.fr-pdp-card');
    if (!scope || scope.dataset.variantImageDisplayReady === '1') return;
    scope.dataset.variantImageDisplayReady = '1';
    const keepInitialProductCover = Boolean(scope.closest?.('[data-fr-initial-product-cover="true"]'));
    syncPdp(scope, !keepInitialProductCover);
  };
  const resetCardDefaults = () => {
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      if (card.dataset.cardVariantInteracted === '1') return;
      const image = card.querySelector('[data-card-image]');
      if (!image?.dataset.cardDefaultImageSrc) return;
      frSyncCardVariantPrice(card, {cardPrice:card.dataset.cardDefaultPrice, cardComparePrice:card.dataset.cardDefaultComparePrice});
      setImage(image, image.dataset.cardDefaultImageSrc, image.dataset.cardDefaultImageAlt, image.dataset.cardDefaultImageSrcset);
      const defaultVariantId = card.dataset.cardDefaultVariantId || '';
      const defaultSwatchKey = card.dataset.cardDefaultSwatchKey || '';
      const variantInput = card.querySelector('input[data-card-variant-id]');
      if (variantInput && defaultVariantId) variantInput.value = defaultVariantId;
      frSyncCollectionCardLinks(card, defaultVariantId);
      card.querySelectorAll('[data-card-swatch]').forEach((button) => {
        const isDefault = Boolean(defaultSwatchKey) && button.dataset.cardSwatchKey === defaultSwatchKey;
        button.classList.toggle('is-active', isDefault);
        button.setAttribute('aria-pressed', isDefault ? 'true' : 'false');
      });
    });
  };
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest && event.target.closest('[data-pdp-thumb]');
    if (!thumb) return;
    event.preventDefault();
    activatePdpThumb(thumb);
  }, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-product-option-button], [data-variant-direct]');
    if (!button || !button.closest('.fr-pdp-card')) return;
    const scope = button.closest('.fr-pdp-card');
    window.requestAnimationFrame(() => syncPdp(scope, true));
  });
  document.addEventListener('pointerdown', (event) => {
    const button = event.target.closest && event.target.closest('[data-card-swatch]');
    const card = button?.closest('[data-product-card]');
    if (card) card.dataset.cardVariantInteracted = '1';
  }, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-card-swatch]');
    const card = button?.closest('[data-product-card]');
    if (card) card.dataset.cardVariantInteracted = '1';
  }, true);
  document.addEventListener('pointerenter', (event) => {
    const button = event.target.closest && event.target.closest('[data-card-swatch]');
    const card = button?.closest('[data-product-card]');
    if (!card || card.dataset.cardVariantInteracted === '1') return;
    window.requestAnimationFrame(resetCardDefaults);
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initPdp();
      resetCardDefaults();
    });
  } else {
    initPdp();
    resetCardDefaults();
  }
  window.addEventListener('load', () => {
    initPdp();
    resetCardDefaults();
  });
  window.setTimeout(resetCardDefaults, 0);
})();

(() => {
  const isDefaultTitle = (value) => String(value || '').trim().toLowerCase() === 'default title';
  const variantLabel = (variant) => {
    if (!variant) return '';
    const title = String(variant.public_title || variant.title || '').trim();
    if (title && !isDefaultTitle(title)) return title;
    const options = Array.isArray(variant.options) ? variant.options.filter((option) => option && !isDefaultTitle(option)) : [];
    return options.join(' / ');
  };
  const currentProductHandle = () => {
    const match = new URL(document.baseURI).pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };
  const cleanImageUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, document.baseURI);
      return (url.origin + url.pathname.replace(/_(?:\d+x\d*|\d+x|x\d+)(?=\.)/i, '')).toLowerCase();
    } catch (error) {
      return String(value).split('?')[0].replace(/_(?:\d+x\d*|\d+x|x\d+)(?=\.)/i, '').toLowerCase();
    }
  };
  const updateImageAlt = (variant) => {
    const image = variant?.featured_image || variant?.featuredImage || variant?.image || null;
    const src = typeof image === 'string' ? image : image?.src || image?.url || '';
    const alt = typeof image === 'string' ? variantLabel(variant) : image?.alt || variantLabel(variant);
    const cleanSrc = cleanImageUrl(src);
    if (!cleanSrc || !alt || isDefaultTitle(alt)) return;
    document.querySelectorAll('[data-pdp-image-src]').forEach((button) => {
      if (cleanImageUrl(button.dataset.pdpImageSrc) === cleanSrc) button.dataset.pdpImageAlt = alt;
    });
    document.querySelectorAll('[data-pdp-main-image], .fr-pdp-thumbs img').forEach((imageNode) => {
      if (cleanImageUrl(imageNode.currentSrc || imageNode.src) === cleanSrc && /default title/i.test(imageNode.alt || '')) {
        imageNode.alt = alt;
      }
    });
  };
  const applyFreshProductData = async () => {
    const scope = document.querySelector('.fr-pdp-card');
    if (!scope) return;
    const directButtons = Array.from(scope.querySelectorAll('[data-variant-direct]'));
    const staleButtons = directButtons.filter((button) => /default title/i.test(button.textContent || ''));
    const variantsNode = scope.querySelector('[data-product-variants]');
    let localVariants = [];
    try {
      localVariants = variantsNode ? JSON.parse(variantsNode.textContent || '[]') : [];
    } catch (error) {
      localVariants = [];
    }
    const staleVariantJson = localVariants.some((variant) => isDefaultTitle(variant.title) || (Array.isArray(variant.options) && variant.options.some(isDefaultTitle)));
    if (!staleButtons.length && !staleVariantJson) return;
    const handle = currentProductHandle();
    if (!handle) return;
    let product = null;
    try {
      const response = await fetch('/products/' + encodeURIComponent(handle) + '.js?frillora_variant_refresh=1', {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) return;
      product = await response.json();
    } catch (error) {
      return;
    }
    const freshVariants = Array.isArray(product?.variants) ? product.variants : [];
    if (!freshVariants.some((variant) => !isDefaultTitle(variant.title) || (Array.isArray(variant.options) && variant.options.some((option) => !isDefaultTitle(option))))) return;
    if (variantsNode) variantsNode.textContent = JSON.stringify(freshVariants);
    const variantById = new Map(freshVariants.map((variant) => [String(variant.id), variant]));
    staleButtons.forEach((button) => {
      const variant = variantById.get(String(button.dataset.variantDirect)) || freshVariants[0];
      const label = variantLabel(variant);
      if (!label || isDefaultTitle(label)) return;
      const labelNode = button.querySelector('span') || button;
      labelNode.textContent = label;
      button.setAttribute('aria-label', label);
    });
    freshVariants.forEach(updateImageAlt);
  };
  const run = () => {
    applyFreshProductData();
    window.setTimeout(applyFreshProductData, 600);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
})();

(() => {
  const announcementTimers = new WeakMap();
  const initAnnouncementRotators = (root = document) => {
    root.querySelectorAll('[data-announcement-rotator]').forEach((rotator) => {
      if (announcementTimers.has(rotator)) return;
      const slides = Array.from(rotator.querySelectorAll('[data-announcement-slide]'));
      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const interval = Math.max(2000, Number(rotator.dataset.announcementInterval) || 4000);
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      const timer = window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        slides[activeIndex].setAttribute('aria-hidden', 'true');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
        slides[activeIndex].setAttribute('aria-hidden', 'false');
      }, interval);
      announcementTimers.set(rotator, timer);
    });
  };
  initAnnouncementRotators();
  document.addEventListener('shopify:section:load', (event) => initAnnouncementRotators(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-announcement-rotator]').forEach((rotator) => {
      const timer = announcementTimers.get(rotator);
      if (timer) window.clearInterval(timer);
      announcementTimers.delete(rotator);
    });
  });
})();

/* FRILLORA-LOCALIZED-LINKS-v1 */
(() => {
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  if (!root || root === '/') return;
  const localize = function localizeStorefrontHref(href, root, origin) {
  if (typeof href !== 'string' || typeof root !== 'string' || root === '/' || !/^\/[A-Za-z0-9-]+\/$/.test(root)) return href;
  const raw = href.trim();
  if (!raw || (!raw.startsWith('/') && !/^https?:\/\//i.test(raw))) return href;
  let url;
  try { url = new URL(raw, origin); } catch { return href; }
  if (!/^https?:$/.test(url.protocol) || url.origin !== origin || url.username || url.password) return href;
  if (/\.(?:js|json)(?:\/|$)/i.test(url.pathname) || (url.pathname.startsWith('/cart/') && url.pathname !== '/cart/')) return href;
  // Locale-prefixed links naturally fail this unprefixed resource allowlist.
  if (url.pathname !== '/' && !/^\/(?:products|collections|pages|blogs|policies|search|cart)(?:\/|$)/.test(url.pathname)) return href;
  // Explicit country/language controls retain their deliberate destination.
  for (const key of url.searchParams.keys()) {
    if (/^(?:country|country_code|language|language_code|locale|shop_locale)$/i.test(key)) return href;
  }
  const localized = root + (url.pathname === '/' ? '' : url.pathname.slice(1)) + url.search + url.hash;
  if (raw.startsWith('//')) return '//' + url.host + localized;
  if (/^https?:\/\//i.test(raw)) return url.origin + localized;
  return localized;
};
  const rewrite = (anchor) => {
    if (!anchor || !anchor.matches('a[href]') || anchor.hasAttribute('download') || anchor.hasAttribute('hreflang') || anchor.closest('form[action*="/localization"],[data-localization-form],[data-localization-selector]')) return;
    const href = anchor.getAttribute('href');
    const next = localize(href, root, window.location.origin);
    if (next !== href) anchor.setAttribute('href', next);
  };
  const scan = (node) => {
    if (!node || (node.nodeType !== 1 && node.nodeType !== 9)) return;
    if (node.nodeType === 1) rewrite(node);
    node.querySelectorAll('a[href]').forEach(rewrite);
  };
  scan(document);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') rewrite(record.target);
      else record.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['href']});
})();

(() => {
  if (window.frPopupCloseGuard) return;
  window.frPopupCloseGuard = true;
  document.addEventListener('click', event => {
    const close = event.target instanceof Element && event.target.closest('button.klaviyo-close-form[aria-label="Close dialog"]');
    const modal = close && close.closest('[data-kl-scroll-locking-modal]');
    if (!modal) return;
    const clearClosedLayer = () => {
      if (!modal.isConnected) return;
      const style = getComputedStyle(modal);
      if (Number(style.opacity) > 0.01 && !style.animationName.toLowerCase().includes('fadeout')) return;
      modal.style.setProperty('pointer-events', 'none', 'important');
      modal.style.setProperty('visibility', 'hidden', 'important');
      modal.style.setProperty('display', 'none', 'important');
      const visibleModal = [...document.querySelectorAll('[data-kl-scroll-locking-modal]')].some(other => {
        const s = getComputedStyle(other), r = other.getBoundingClientRect();
        return s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) > 0 && r.width > 0 && r.height > 0;
      });
      if (!visibleModal) document.body.classList.remove('klaviyo-prevent-body-scrolling');
    };
    setTimeout(clearClosedLayer, 600);
    setTimeout(clearClosedLayer, 1200);
  }, true);
})();
window.frPdpCouponTiersConfig = {"forms":{"ar":{"eight":"Yqufg3","twelve":"VvfM4z"},"cs":{"eight":"SqLNaj","twelve":"TN4pVQ"},"da":{"eight":"VSYiFn","twelve":"SXKQtU"},"de":{"eight":"RdWdai","twelve":"Wmk6Dz"},"el":{"eight":"VexvWA","twelve":"TDYpjL"},"en":{"eight":"Uiis56","twelve":"WEiBVw"},"es":{"eight":"WRtCJQ","twelve":"WEc7Tx"},"fi":{"eight":"Y86Y2s","twelve":"WxxRpC"},"fr":{"eight":"XZsHwx","twelve":"TZsELB"},"he":{"eight":"U44UXu","twelve":"U6Fbam"},"hu":{"eight":"R6PsBv","twelve":"Yz2ZSu"},"it":{"eight":"XwRFwT","twelve":"STQAak"},"ja":{"eight":"RM3Ztm","twelve":"TC69aH"},"nb":{"eight":"VAX3sG","twelve":"VNPNkm"},"nl":{"eight":"UegFHx","twelve":"VwV39E"},"pl":{"eight":"WJW8ep","twelve":"XjWaGv"},"pt-PT":{"eight":"UX7uLg","twelve":"XvMVrD"},"ro":{"eight":"SSLQ56","twelve":"VFm3LD"},"sl":{"eight":"SQKPUz","twelve":"STn67s"},"sv":{"eight":"XpJUY6","twelve":"TyZnUW"}},"codes":{"eight":"WELCOME8","twelve":"WELCOME12"},"productPagesOnly":true,"initialDelaySeconds":12,"retiredFormIds":["YnWSru","YaH2jP","SAa6Uy","SVRCnQ","TBuVck","XWBfnc","WEy9Yr","RqvZZf"]};
(() => {
  if (window.frPdpCouponTiers) return;
  const version = '2026-11-04.3';
  const input = window.frPdpCouponTiersConfig;
  const fail = status => { window.frPdpCouponTiers = { version, status }; };
  if (window.frPdpCouponReminder) return fail('legacy-helper-conflict');
  if (!input || !input.forms || !input.forms.en) return fail('configuration-missing');
  const stages = ['eight', 'twelve'];
  const durations = { eight: 900000, twelve: 300000 };
  const codes = { eight: input.codes?.eight || 'WELCOME8', twelve: input.codes?.twelve || 'WELCOME12' };
  const byId = new Map();
  for (const [locale, forms] of Object.entries(input.forms)) {
    for (const stage of stages) {
      const id = forms?.[stage];
      if (typeof id !== 'string' || !/^[A-Za-z0-9]+$/.test(id) || byId.has(id)) return fail('configuration-invalid');
      byId.set(id, { id, locale, stage });
    }
  }
  const retiredFormIds = input.retiredFormIds || [];
  if (!Array.isArray(retiredFormIds) || retiredFormIds.some(id => typeof id !== 'string' || !/^[A-Za-z0-9]+$/.test(id) || byId.has(id))) return fail('configuration-invalid');
  if (Object.values(codes).some(code => typeof code !== 'string' || !/^[A-Za-z0-9_-]+$/.test(code)) || codes.eight === codes.twelve) return fail('configuration-invalid');
  const SESSION_KEY = 'fr_coupon_tiers_session_v1';
  const COOLDOWN_KEY = 'fr_coupon_tiers_closed_until';
  const LEGACY_KEY = 'fr_pdp_coupon_closed_until';
  const DAY = 86400000;
  const IDLE = 1800000;
  const threshold = 120000;
  const initialDelay = Number.isFinite(input.initialDelaySeconds) && input.initialDelaySeconds >= 0 ? input.initialDelaySeconds * 1000 : 12000;
  const now = () => Date.now();
  const cookieGet = key => {
    try {
      const entry = String(document.cookie || '').split(';').map(value => value.trim()).find(value => value.startsWith(key + '='));
      return entry ? decodeURIComponent(entry.slice(key.length + 1)) : null;
    } catch (error) { return null; }
  };
  const cookieSet = (key, value, maxAge) => {
    try { document.cookie = key + '=' + encodeURIComponent(value) + '; Path=/; SameSite=Lax' + (maxAge === undefined ? '' : '; Max-Age=' + maxAge) + (location.protocol === 'https:' ? '; Secure' : ''); } catch (error) {}
  };
  let memoryCooldown = 0;
  const suppressedUntil = () => {
    let until = memoryCooldown;
    for (const key of [COOLDOWN_KEY, LEGACY_KEY]) {
      let stored = 0;
      try { stored = Number(window.localStorage.getItem(key)) || 0; } catch (error) {}
      const value = Math.max(stored, Number(cookieGet(key)) || 0);
      if (Number.isFinite(value)) until = Math.max(until, value);
    }
    return until;
  };
  const rememberTwelveClose = () => {
    const until = now() + DAY;
    memoryCooldown = until;
    for (const key of [COOLDOWN_KEY, LEGACY_KEY]) {
      try { window.localStorage.setItem(key, String(until)); } catch (error) {}
      cookieSet(key, String(until), 86400);
    }
  };
  const fresh = () => ({ schema: 1, activeMs: 0, lastSeen: now(), stages: { eight: { shown: false, dismissed: false, copied: false, deadline: 0 }, twelve: { shown: false, dismissed: false, copied: false, deadline: 0 } } });
  const load = () => {
    let raw;
    try { raw = window.sessionStorage.getItem(SESSION_KEY); } catch (error) {}
    if (!raw) raw = cookieGet(SESSION_KEY);
    try {
      const value = JSON.parse(raw);
      if (value?.schema !== 1 || !Number.isFinite(value.activeMs) || value.activeMs < 0 || value.activeMs > DAY || !Number.isFinite(value.lastSeen) || now() - value.lastSeen > IDLE || value.lastSeen > now() + 60000) return fresh();
      for (const stage of stages) {
        const entry = value.stages?.[stage];
        if (!entry || typeof entry.shown !== 'boolean' || typeof entry.dismissed !== 'boolean' || typeof entry.copied !== 'boolean' || !Number.isFinite(entry.deadline) || entry.deadline < 0) return fresh();
      }
      return value;
    } catch (error) { return fresh(); }
  };
  let session = load();
  let lastSaved = 0;
  const save = force => {
    if (!force && now() - lastSaved < 1000) return;
    session.lastSeen = now();
    const value = JSON.stringify(session);
    let saved = false;
    try { window.sessionStorage.setItem(SESSION_KEY, value); saved = true; } catch (error) {}
    // Only use a session cookie when tab-local browser storage is unavailable.
    if (!saved) cookieSet(SESSION_KEY, value);
    lastSaved = now();
  };
  const formSelector = [...byId.keys()].map(id => `[data-testid="klaviyo-form-${id}"],.klaviyo-form-${id}`).join(',');
  const localeKey = value => String(value || '').replace(/_/g, '-').toLowerCase();
  const locales = new Map(Object.keys(input.forms).map(locale => [localeKey(locale), locale]));
  const selectLocale = () => {
    let prefix = '';
    try { prefix = decodeURIComponent(location.pathname.split('/').filter(Boolean)[0] || ''); } catch (error) {}
    if (locales.has(localeKey(prefix))) return locales.get(localeKey(prefix));
    const lang = localeKey(document.documentElement?.lang);
    if (locales.has(lang)) return locales.get(lang);
    if (lang === 'pt' && locales.has('pt-pt')) return locales.get('pt-pt');
    if (lang === 'no' && locales.has('nb')) return locales.get('nb');
    const base = lang.split('-')[0];
    return locales.get(base) || (Object.hasOwn(input.forms, input.defaultLocale) ? input.defaultLocale : 'en');
  };
  const eligiblePage = () => input.productPagesOnly === false || /(?:^|\/)products\/[^/]+/.test(location.pathname) && document.body?.classList.contains('fr-template-product');
  const visible = element => {
    if (!element?.isConnected) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && !(style.animationName || '').toLowerCase().includes('fadeout') && element.getBoundingClientRect().width > 0;
  };
  const blockingSelector = '[role="dialog"],[aria-modal="true"],dialog[open],[data-kl-scroll-locking-modal],.fr-cart-drawer,.fr-size-modal,.fr-size-guide-modal,.fr-mobile-menu,.fr-filter-panel,[data-fr-size-modal],[data-size-dialog]';
  const hasBlockingLayer = ownDialog => [...document.querySelectorAll(blockingSelector)].some(element => {
    if (ownDialog && (element === ownDialog || ownDialog.contains(element) || element.contains(ownDialog))) return false;
    if (!visible(element) || element.hidden || element.getAttribute('aria-hidden') === 'true' || element.closest('[aria-hidden="true"],[hidden]')) return false;
    const style = getComputedStyle(element), rect = element.getBoundingClientRect();
    if (Number(style.opacity) <= 0 || rect.width <= 0 || rect.height <= 0) return false;
    const width = window.innerWidth || document.documentElement.clientWidth || 1024;
    const height = window.innerHeight || document.documentElement.clientHeight || 768;
    const left = rect.left || 0, top = rect.top || 0;
    const right = Number.isFinite(rect.right) ? rect.right : left + rect.width;
    const bottom = Number.isFinite(rect.bottom) ? rect.bottom : top + rect.height;
    return right > 0 && bottom > 0 && left < width && top < height;
  });
  const nativeClose = dialog => dialog.querySelector('button.klaviyo-close-form') || dialog.querySelector('.fr-pdp-coupon-close button');
  let active = null;
  let pending = null;
  let interval = null;
  let lastTick = now();
  let lastVisible = document.visibilityState !== 'hidden';
  let stopped = false;
  let initialIntent = false;
  let lastCloseReason = null;
  let waitUntil = 0;
  let feedback = null;
  let feedbackTimer = null;
  let feedbackWatchdog = null;
  let feedbackEnd = null;
  let feedbackGeneration = 0;
  const nativeDeadlines = new WeakMap();
  const closingDialogs = new WeakSet();
  let teaserStyle = null;
  const removeFeedback = () => {
    feedbackGeneration++;
    clearTimeout(feedbackTimer); clearTimeout(feedbackWatchdog);
    if (feedbackEnd) feedback?.removeEventListener('animationend', feedbackEnd);
    feedback?.remove(); feedback = null; feedbackEnd = null;
  };
  const showFeedback = state => {
    removeFeedback();
    feedback = document.createElement('div');
    feedback.id = 'fr-pdp-coupon-copy-feedback'; feedback.className = 'fr-pdp-coupon-feedback';
    feedback.setAttribute('role', 'status'); feedback.setAttribute('aria-live', 'polite'); feedback.setAttribute('aria-atomic', 'true');
    document.body.appendChild(feedback);
    const node = feedback, generation = ++feedbackGeneration;
    const current = () => feedback === node && generation === feedbackGeneration && node.isConnected;
    const running = () => (node.getAnimations?.() || []).filter(animation => animation.animationName === 'fr-pdp-coupon-feedback-fade' && (animation.pending || animation.playState === 'running' || animation.playState === 'paused'));
    const finish = () => { if (current()) removeFeedback(); };
    feedbackEnd = event => { if (event.target === node && event.animationName === 'fr-pdp-coupon-feedback-fade') finish(); };
    node.addEventListener('animationend', feedbackEnd);
    node.textContent = state.copiedLabel;
    node.setAttribute('data-fr-copy-feedback-active', '');
    feedbackTimer = setTimeout(() => {
      if (!current()) return;
      const animations = running();
      if (animations.length) Promise.allSettled(animations.map(animation => animation.finished)).then(() => { if (current() && !running().length) finish(); });
      else finish();
    }, 4000);
    feedbackWatchdog = setTimeout(() => { if (current() && (document.visibilityState === 'hidden' || !running().length)) finish(); }, 12000);
    waitUntil = Math.max(waitUntil, now() + 4000);
  };
  const cleanupClosedLayer = dialog => {
    const cleanup = () => {
      if (!dialog.isConnected) return;
      const style = getComputedStyle(dialog);
      if (!(style.animationName || '').toLowerCase().includes('fadeout') || Number(style.opacity) > 0.01) return;
      dialog.style.setProperty('pointer-events', 'none', 'important'); dialog.style.setProperty('visibility', 'hidden', 'important'); dialog.style.setProperty('display', 'none', 'important');
      closingDialogs.delete(dialog);
      if (![...document.querySelectorAll('[data-kl-scroll-locking-modal]')].some(other => visible(other) && Number(getComputedStyle(other).opacity) > 0.01)) document.body.classList.remove('klaviyo-prevent-body-scrolling');
    };
    setTimeout(cleanup, 600); setTimeout(cleanup, 1200);
  };
  const finishActive = reason => {
    if (!active) return;
    const state = active;
    active = null;
    state.observer?.disconnect();
    if (reason !== 'pagehide') {
      closingDialogs.add(state.dialog);
      nativeDeadlines.delete(state.form);
      waitUntil = Math.max(waitUntil, now() + 700);
    }
    if (!['pagehide', 'suppressed', 'wrong-locale', 'stale-stage', 'overlay-suppressed'].includes(reason)) {
      session.stages[state.stage].dismissed = true;
      if (reason === 'coupon-copied') session.stages[state.stage].copied = true;
      if (state.stage === 'twelve') rememberTwelveClose();
      save(true);
    }
    lastCloseReason = reason;
    cleanupClosedLayer(state.dialog);
    syncTeasers();
  };
  const closeActive = reason => {
    if (!active) return false;
    const state = active, close = nativeClose(state.dialog);
    if (!close) return false;
    state.closeReason = reason;
    close.click();
    if (active === state) finishActive(reason);
    waitUntil = Math.max(waitUntil, now() + 700);
    return true;
  };
  const copiedSuccessfully = state => state.copyAttempted && [...state.form.querySelectorAll('[role="alert"],[role="status"]')].some(element => visible(element) && element.textContent.trim() === state.copiedLabel);
  const finishCopied = state => {
    if (active !== state || !copiedSuccessfully(state)) return false;
    showFeedback(state); closeActive('coupon-copied');
    return true;
  };
  const render = state => {
    const coupon = state.form.querySelector('.fr-pdp-coupon-copy');
    if (coupon) {
      const walker = document.createTreeWalker(coupon, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) if (node.nodeValue.trim() === codes[state.stage]) node.nodeValue = state.label;
      const button = coupon.matches('button,[role="button"]') ? coupon : coupon.querySelector('button,[role="button"]');
      if (button && button.textContent.trim() === state.label && button.getAttribute('aria-label') !== state.label) button.setAttribute('aria-label', state.label);
    }
    const remaining = Math.max(0, state.deadline - now());
    const fill = state.form.querySelector('[data-fr-reminder-progress]');
    if (fill) fill.style.transform = `scaleX(${remaining / durations[state.stage]})`;
    // The native timer is configured to 15/5 minutes by the form definition.
    // Each stage opens once per session; its DOM and countdown stay native.
    if (finishCopied(state)) return;
    else if (remaining <= 0) closeActive('reminder-expired');
  };
  const inspect = () => {
    if (active) {
      if (finishCopied(active)) return;
      if (!active.form.isConnected || !visible(active.dialog)) finishActive(active.closeReason || 'native-close');
      else if (suppressedUntil() > now()) closeActive('suppressed');
      else render(active);
      // A native close can leave its form visibly mounted until the fade-out
      // starts. Never adopt it again in the same inspection that closed it.
      return;
    }
    for (const form of document.querySelectorAll(formSelector)) {
      const id = [...byId.keys()].find(candidate => form.getAttribute('data-testid') === `klaviyo-form-${candidate}` || form.classList.contains(`klaviyo-form-${candidate}`));
      const target = byId.get(id), marker = form.querySelector('[data-fr-pdp-coupon]');
      if (!target || !marker) continue;
      const dialog = form.closest('[role="dialog"]') || form.closest('[data-kl-scroll-locking-modal]');
      if (dialog && closingDialogs.has(dialog)) {
        if (!visible(dialog)) closingDialogs.delete(dialog);
        continue;
      }
      if (!dialog || !visible(dialog) || !nativeClose(dialog)) continue;
      if (hasBlockingLayer(dialog)) {
        nativeClose(dialog).click(); cleanupClosedLayer(dialog);
        if (pending?.id === id) pending = null;
        lastCloseReason = 'overlay-suppressed'; waitUntil = Math.max(waitUntil, now() + 700);
        continue;
      }
      if (marker.dataset.frCouponCode !== codes[target.stage]) {
        nativeClose(dialog).click(); cleanupClosedLayer(dialog);
        lastCloseReason = 'unmigrated-form';
        continue;
      }
      const wrongLocale = target.locale !== selectLocale();
      const stale = target.stage === 'eight' && session.activeMs >= threshold && !nativeDeadlines.has(form) || target.stage === 'twelve' && session.activeMs < threshold;
      if (suppressedUntil() > now() || wrongLocale || stale || !eligiblePage()) {
        nativeClose(dialog).click(); cleanupClosedLayer(dialog);
        lastCloseReason = suppressedUntil() > now() ? 'suppressed' : wrongLocale ? 'wrong-locale' : 'stale-stage';
        continue;
      }
      const entry = session.stages[target.stage];
      // Klaviyo restarts its native timer on manual teaser opens. Preserve the
      // same DOM's running deadline only when returning through BFCache.
      entry.deadline = nativeDeadlines.get(form) || now() + durations[target.stage];
      nativeDeadlines.set(form, entry.deadline);
      entry.shown = true;
      active = { ...target, form, dialog, deadline: entry.deadline, copyAttempted: false, label: marker.dataset.frCouponCopyLabel || (target.stage === 'eight' ? 'Copy my 8% code' : 'Copy my 12% code'), copiedLabel: marker.dataset.frCouponCopiedLabel || 'Code copied', closeReason: null };
      const state = active;
      state.observer = new MutationObserver(() => { if (active === state) render(state); });
      state.observer.observe(form, { childList: true, characterData: true, subtree: true });
      if (pending?.stage === target.stage) pending = null;
      save(true); render(active);
      break;
    }
  };
  const maybeOpen = () => {
    if (active || stopped || document.visibilityState === 'hidden' || !eligiblePage() || suppressedUntil() > now() || now() < waitUntil || feedback?.isConnected || hasBlockingLayer(null)) return;
    const stage = session.activeMs >= threshold ? 'twelve' : 'eight';
    if (pending && pending.stage !== stage) pending = null;
    if (pending && now() - pending.at < 15000) return;
    if (session.stages[stage].shown || session.stages[stage].dismissed || stage === 'eight' && session.activeMs < initialDelay && !initialIntent) return;
    const locale = selectLocale(), id = input.forms[locale]?.[stage];
    if (!id) return;
    const attempts = pending?.stage === stage ? pending.attempts + 1 : 1;
    if (attempts > 3) return;
    pending = { stage, id, at: now(), attempts };
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  };
  const syncTeasers = () => {
    if (!document.body) return;
    if (!teaserStyle?.isConnected) {
      teaserStyle = document.getElementById('fr-pdp-coupon-tiers-teasers');
      if (!teaserStyle) {
        teaserStyle = document.createElement('style'); teaserStyle.id = 'fr-pdp-coupon-tiers-teasers';
        (document.head || document.documentElement).appendChild(teaserStyle);
      }
    }
    const stage = session.activeMs >= threshold ? 'twelve' : 'eight';
    const currentId = input.forms[selectLocale()]?.[stage];
    const hideAll = stopped || !eligiblePage() || document.visibilityState === 'hidden' || suppressedUntil() > now() || !!active || !!feedback?.isConnected || hasBlockingLayer(null);
    const hiddenIds = [...byId.keys()].filter(id => hideAll || id !== currentId).concat(retiredFormIds);
    const css = hiddenIds.length ? hiddenIds.map(id => '.kl-teaser-' + id).join(',') + '{display:none!important;visibility:hidden!important;pointer-events:none!important}' : '';
    if (teaserStyle.textContent !== css) teaserStyle.textContent = css;
  };
  const accountTime = () => {
    const current = now(), delta = current - lastTick;
    // Long suspended callbacks do not establish visible browsing time.
    if (lastVisible && delta >= 0 && delta <= 2500) session.activeMs = Math.min(DAY, session.activeMs + delta);
    lastTick = current; lastVisible = document.visibilityState !== 'hidden';
    save(false);
  };
  const tick = () => { if (!stopped) { accountTime(); inspect(); syncTeasers(); maybeOpen(); } };
  const api = {
    version, status: 'ready',
    get state() { return { locale: selectLocale(), activeMs: session.activeMs, stage: session.activeMs >= threshold ? 'twelve' : 'eight', activeFormId: active?.id || null, remainingSeconds: active ? Math.max(0, Math.ceil((active.deadline - now()) / 1000)) : null, shown: { eight: session.stages.eight.shown, twelve: session.stages.twelve.shown }, lastCloseReason, pendingFormId: pending?.id || null }; },
    get suppressedUntil() { return suppressedUntil(); },
  };
  window.frPdpCouponTiers = api;
  // Keep the previous observer/debug handle and prevent an old helper from starting later.
  window.frPdpCouponReminder = api;
  const begin = () => {
    if (!document.body) return;
    stopped = false; lastTick = now(); lastVisible = document.visibilityState !== 'hidden';
    if (!document.getElementById('fr-pdp-coupon-reminder-style')) {
      const style = document.createElement('style'); style.id = 'fr-pdp-coupon-reminder-style';
      style.textContent = '.fr-pdp-coupon-copy :is(button,[role="button"])>svg{display:none!important}.fr-pdp-coupon-copy :is(button,[role="button"])::before{content:"";display:block;box-sizing:border-box;width:11px;height:13px;border:1px solid currentColor;border-radius:1px;box-shadow:-3px -3px 0 -1px #C8326B,-3px -3px 0 0 currentColor;margin-left:3px;margin-top:3px;flex:none}.fr-pdp-coupon-feedback{position:fixed;top:68%;left:50%;transform:translate(-50%,-50%);z-index:2147483647;box-sizing:border-box;width:max-content;max-width:calc(100vw - 32px);padding:13px 19px;border:1px solid #e7c5d4;border-radius:12px;background:#3a2533;color:#fff;box-shadow:0 8px 28px #3a253326;font-family:inherit;font-size:14px;font-weight:500;line-height:1.5;letter-spacing:normal;text-align:center;overflow-wrap:anywhere;pointer-events:none;opacity:0}.fr-pdp-coupon-feedback[data-fr-copy-feedback-active]:not(:empty){animation:fr-pdp-coupon-feedback-fade 4s ease both}@keyframes fr-pdp-coupon-feedback-fade{0%{opacity:0}5%{opacity:1}92.5%{opacity:1}100%{opacity:0}}@media(prefers-reduced-motion:reduce){.fr-pdp-coupon-feedback[data-fr-copy-feedback-active]:not(:empty){animation:none;opacity:1}}';
      (document.head || document.documentElement).appendChild(style);
    }
    if (interval === null) interval = setInterval(tick, 250);
    tick();
  };
  document.addEventListener('click', event => {
    const state = active;
    if (!state || !(event.target instanceof Element)) return;
    const coupon = event.target.closest('.fr-pdp-coupon-copy');
    if (coupon && state.form.contains(coupon)) state.copyAttempted = true;
    const close = event.target.closest('button.klaviyo-close-form');
    if (close && state.dialog.contains(close)) finishActive(state.closeReason || 'native-close');
  }, true);
  document.addEventListener('visibilitychange', () => { accountTime(); syncTeasers(); if (document.visibilityState !== 'hidden') tick(); });
  document.addEventListener('scroll', () => {
    const height = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    if (height > 0 && window.scrollY / height >= 0.28) { initialIntent = true; tick(); }
  }, { passive: true });
  document.addEventListener('mouseout', event => { if (!event.relatedTarget && event.clientY <= 0) { initialIntent = true; tick(); } });
  window.addEventListener('klaviyoForms', () => { if (!stopped) tick(); });
  window.addEventListener('pagehide', () => {
    accountTime(); save(true); stopped = true;
    if (interval !== null) clearInterval(interval); interval = null;
    finishActive('pagehide'); pending = null; removeFeedback();
    syncTeasers();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) begin(); });
  if (document.body) begin(); else document.addEventListener('DOMContentLoaded', begin, { once: true });
})();
